import ResetTviConnectSection from './ResetTviConnectSection'

export default ResetTviConnectSection
